import script from "./WineFranceGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./WineFranceGuide.vue?vue&type=script&lang=ts&setup=true"

import "./WineFranceGuide.vue?vue&type=style&index=0&id=408bc96b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408bc96b"]])

export default __exports__